const STORAGE_KEY = "siteSearch.recent.v1";
const MAX_ITEMS = 8;
function safeParseJson(raw) {
    if (!raw)
        return null;
    try {
        return JSON.parse(raw);
    }
    catch (_a) {
        return null;
    }
}
export function loadRecentSearches() {
    if (typeof window === "undefined")
        return [];
    const parsed = safeParseJson(window.localStorage.getItem(STORAGE_KEY));
    if (!Array.isArray(parsed))
        return [];
    return parsed
        .filter((x) => !!x &&
        typeof x === "object" &&
        typeof x.name === "string" &&
        typeof x.url === "string" &&
        typeof x.type === "string" &&
        typeof x.type_name === "string" &&
        typeof x.savedAt === "number")
        .sort((a, b) => b.savedAt - a.savedAt)
        .slice(0, MAX_ITEMS);
}
export function saveRecentSearch(item) {
    if (typeof window === "undefined")
        return [];
    const nextItem = {
        type: item.type,
        type_name: item.type_name,
        name: item.name,
        url: item.url,
        body_types: item.body_types,
        savedAt: Date.now(),
    };
    const current = loadRecentSearches();
    const deduped = current.filter((x) => x.url !== nextItem.url);
    const next = [nextItem, ...deduped].slice(0, MAX_ITEMS);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    return next;
}
export function clearRecentSearches() {
    if (typeof window === "undefined")
        return;
    window.localStorage.removeItem(STORAGE_KEY);
}
